import React, { useState } from 'react';
import { ModalBody, Text, ModalFooter, Button, Alert, Flex, Box, } from '@spothero/ui';
import { MoreTime } from '@spothero/icons';
import NewTimesDisplay from '../new-times-display';
import FormatUtils from 'utils/format';
import PaymentPicker, { ADD_NEW_CARD_VALUE, CARD_FORM_ID, usePaymentForm, } from 'common/payment-picker';
import { useDispatch, useSelector } from 'react-redux';
import UserUtils from 'utils/user-utils';
import { refreshUser } from 'store/user/user-actions';
import { updateReservationTimes } from 'store/parking-pass/parking-pass-actions';
const ChangeTimesPayment = ({ onCloseModal, handleBackToTimeSelect, rateDiff, timezone, isAutoExtension, isSubmitting, reservation, onSuccess, setIsSubmitting, onError, }) => {
    const dispatch = useDispatch();
    const { status: userStatus } = useSelector((state) => state.user.data);
    const [fullCreditError, setFullCreditError] = useState(false);
    const fullCredit = rateDiff.priceBreakdown.chargeAmount.charge === 0;
    const { control, handleSubmit, setError, formState: { errors }, } = usePaymentForm();
    const chargeAmount = FormatUtils.price(rateDiff.priceBreakdown.chargeAmount.charge).displayPrice;
    const creditAmount = FormatUtils.price(rateDiff.priceBreakdown.chargeAmount.credit).displayPrice;
    const onSubmitCard = ({ cardValue, stripeToken, } = {}) => {
        setIsSubmitting(true);
        return dispatch(updateReservationTimes({
            reservationId: reservation.rentalId,
            rateDiff,
            timezone,
            cardExternalId: cardValue,
            stripeToken,
        }));
    };
    const onFailure = (errorMessage) => {
        onError(errorMessage);
    };
    const handleSuccess = ({ cardValue } = {}) => {
        onSuccess();
        if (cardValue === ADD_NEW_CARD_VALUE &&
            userStatus === UserUtils.AUTH_STATE.USER) {
            try {
                dispatch(refreshUser());
            }
            catch { } // eslint-disable-line no-empty
        }
    };
    const onFullCreditSubmit = async () => {
        setIsSubmitting(true);
        setFullCreditError(false);
        const response = await onSubmitCard();
        // @ts-expect-error
        if (response.success) {
            handleSuccess();
        }
        else {
            // @ts-expect-error
            onError(response.error);
            setFullCreditError(true);
        }
    };
    return (<>
            <ModalBody flexDirection="column" data-testid="ChangeTimesPayment">
                {isAutoExtension && (<Alert overflow="visible" marginBottom={6} showIcon icon={MoreTime} status="neutral" description="You're getting more time than you selected at no additional cost. Happy parking!"/>)}
                <NewTimesDisplay rateDiff={rateDiff} timezone={timezone} handleBackToTimeSelect={handleBackToTimeSelect}/>
                {rateDiff.priceBreakdown.chargeAmount.credit > 0 ? (<>
                        <Flex marginTop={4} flexDirection="column">
                            <Text fontWeight="semibold" fontSize="sm" color="text.secondary.light">
                                SpotHero Credit Applied
                            </Text>
                            <Text>${creditAmount}</Text>
                        </Flex>
                        <Flex marginTop={4} flexDirection="column">
                            <Text fontWeight="semibold" fontSize="sm" color="text.secondary.light">
                                Remaining Payment Amount
                            </Text>
                            <Text>${chargeAmount}</Text>
                        </Flex>
                    </>) : (<Flex marginTop={4} flexDirection="column">
                        <Text fontWeight="semibold" fontSize="sm" color="text.secondary.light">
                            Payment Due
                        </Text>
                        <Text>${chargeAmount}</Text>
                    </Flex>)}
                {!fullCredit ? (<Box marginTop={6}>
                        <PaymentPicker control={control} errors={errors} setError={setError} handleSubmit={handleSubmit} onSubmitCard={onSubmitCard} onSuccess={handleSuccess} onFailure={onFailure}/>
                    </Box>) : null}
                {fullCreditError && (<Alert title="Oops, we hit a snag changing your reservation." description="Please try again." showIcon status="error" size="md" marginBottom={4} marginTop={4}/>)}
            </ModalBody>
            <ModalFooter justifyContent="end" gap={4} flexDirection={{ base: 'column', desktop: 'row-reverse' }}>
                {fullCredit ? (<Button loadingText={'Update Reservation'} data-testid="ChangeTimesPayment-update-reservation-button" width={{ base: '100%', desktop: 'auto' }} onClick={onFullCreditSubmit} disabled={isSubmitting}>
                        Update Reservation
                    </Button>) : (<Button loadingText={'Update Reservation'} data-testid="ChangeTimesPayment-update-reservation-button" width={{ base: '100%', desktop: 'auto' }} form={CARD_FORM_ID} type="submit" disabled={isSubmitting}>
                        Update Reservation
                    </Button>)}
                <Button width={{ base: '100%', desktop: 'auto' }} onClick={() => onCloseModal()} variant="secondary">
                    Cancel
                </Button>
            </ModalFooter>
        </>);
};
export default ChangeTimesPayment;
